// FETCH TIPS
export const FETCH_STORY_COMMENTS_REQUEST = 'story-comments/FETCH_STORY_COMMENTS_REQUEST';
export const FETCH_STORY_COMMENTS_COMPLETED = 'story-comments/FETCH_STORY_COMMENTS_COMPLETED';
export const FETCH_STORY_COMMENTS_FAILED = 'story-comments/FETCH_STORY_COMMENTS_FAILED';

export const FETCH_COMMENTS_BY_FILTER_REQUEST = 'story-comments/FETCH_COMMENTS_BY_FILTER_REQUEST';
export const FETCH_COMMENTS_BY_FILTER_COMPLETED = 'story-comments/FETCH_COMMENTS_BY_FILTER_COMPLETED';
export const FETCH_COMMENTS_BY_FILTER_FAILED = 'story-comments/FETCH_COMMENTS_BY_FILTER_FAILED';

export const FETCH_NEW_COMMENTS_REQUEST = 'story-comments/FETCH_NEW_COMMENTS_REQUEST';
export const FETCH_NEW_COMMENTS_COMPLETED = 'story-comments/FETCH_NEW_COMMENTS_COMPLETED';
export const FETCH_NEW_COMMENTS_FAILED = 'story-comments/FETCH_NEW_COMMENTS_FAILED';

export const COMMENT_LIKE_REQUEST = 'story-comments/COMMENT_LIKE_REQUEST';
export const COMMENT_LIKE_COMPLETED = 'story-comments/COMMENT_LIKE_COMPLETED';
export const COMMENT_LIKE_FAILED = 'story-comments/COMMENT_LIKE_FAILED';

export const COMMENT_DELETE_REQUEST = 'story-comments/COMMENT_DELETE_REQUEST';
export const COMMENT_DELETE_COMPLETED = 'story-comments/COMMENT_DELETE_COMPLETED';
export const COMMENT_DELETE_FAILED = 'story-comments/COMMENT_DELETE_FAILED';

export const SEND_COMMENT_REQUEST = 'story-comments/SEND_COMMENT_REQUEST';
export const SEND_COMMENT_COMPLETED = 'story-comments/SEND_COMMENT_COMPLETED';
export const SEND_COMMENT_FAILED = 'story-comments/SEND_COMMENT_FAILED';

export const COMMENT_UPDATE_COMPLETED = 'story-comments/COMMENT_UPDATE_COMPLETED';
